import React from "react";
// import { makeStyles } from "@mui/styles"; 
import {
  Typography,
  CardContent,
  Divider,
  CardHeader,
  IconButton,
  Link,
  Card,
  Box,
} from "@mui/material";

import VolumeUpOutlinedIcon from '@mui/icons-material/VolumeUpOutlined';


const WordCard = ({ word }) => {
    if (!word) return null;

    return (
        <Card variant="outlined" sx={{ maxWidth: 300 }}>
            <CardContent>
                <Typography 
                    variant="h6" 
                    gutterBottom 
                    align="center"
                    sx={word.isPhrasalVerb ? { fontStyle: 'italic', color: '#1976d2' } : {}}
                >
                    {word.lemma}
                </Typography>
                
                <Divider sx={{ my: 1 }} />
                
                {word.translation && (
                    <Typography variant="body1" sx={{ mb: 1 }} align="center">
                        {word.translation}
                    </Typography>
                )}

                {(word.link || word.linkTitle) && (
                    <Box sx={{ mt: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                            Read:{' '}
                            <Link 
                                href={word.link} 
                                target="_blank" 
                                rel="noopener noreferrer"
                            >
                                {word.linkTitle || word.link}
                            </Link>
                        </Typography>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default WordCard;